import app from 'flarum/forum/app';
//import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionListState from 'flarum/states/DiscussionListState';

//import { ApiResponsePlural } from 'flarum/common/Store';

export default class HomeDiscussionsState extends DiscussionListState {
	constructor(params, page, pageSize, preloadedKey = 'discussions') {
		super(params, page);

		// DiscussionListState doesn't allow passing of pageSize
		// so we need to set it here explicitly
		this.pageSize = pageSize;

		this.preloadedKey = preloadedKey;
	}

	requestParams() {
		const original = super.requestParams();
		return {
			...original,
			filter: { language: app.translator.getLocale(), ...(this.params.filter || {}) },
			sort: this.params.sort ? this.params.sort : '-lastPostedAt',
			page: { offset: 0, limit: this.pageSize },
			include: [...(original.include || []), ...(this.params.include || [])],
		};
	}

	loadPage(page = 1) {
		const preloadedDiscussions = app.preloadedHomeApiDocument(this.preloadedKey);
		//const preloadedDiscussions = app.preloadedApiDocument(this.preloadedKey);

		if (preloadedDiscussions) {
			this.initialLoading = false;

			return Promise.resolve(preloadedDiscussions);
		}

		const params = this.requestParams();
		params.page = {
			offset: this.pageSize * (page - 1),
			...params.page,
		};

		if (Array.isArray(params.include)) {
			params.include = params.include.join(',');
		}

		return app.store.find(this.type, params);
	}
}